

























































































import debounce from 'lodash/debounce';

import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapState, mapActions } from 'vuex';
import { validationMixin } from 'vuelidate'
import { required, requiredIf, minLength, sameAs } from 'vuelidate/lib/validators'

import { getFieldError } from '@/core/tools/forms/get_field_error';
import { buildEquipmentBatchNumber } from '@/utils/batchNumber';

import { STORE_KEY as PARENT_STORE_KEY } from '../_store';
import { STORE_KEY, store } from './_store';
import Attachments from '@/components/Controls/Attachments.vue';

@Component({
  mixins: [ validationMixin ],
  computed: {
    ...mapState(PARENT_STORE_KEY, [
      'relatedPlansList'
    ]),
    ...mapState(STORE_KEY, [
      'loaded', 'loading', 'fatalError',
      'document', 'form', 'meta', 'storages'
    ]),
    ...mapGetters(STORE_KEY, [
      'fields'
    ])
  },
  methods: {
    getFieldError
  },
  validations() {
    const rules: any = {
      product_id: { required },
      number: { required },
    }

    return {
      form: rules
    }
  },
  components: {
    Attachments
  }
})
export default class ShiftCustomPlanForm extends Vue {
  @Prop({ type: Boolean }) isNew!: boolean;
  @Prop({ type: Object }) documentPreview!: any;
  @Prop({ type: Object }) initParams!: any;
  @Prop({ type: String }) documentId!: any;
  @Prop({ type: String }) relTimeOfDay!: string;

  document!: any
  form!: any
  relatedPlansList!: any[]

  logo_id: number|null = null;
  // предыдущий выбор оборудования: отличаем синтетический input-object(undefined)
  // при загрузке комбобокса от реальной очистки значения пользователем
  previousEquipmentId: number|null = null;
  group: number|null = null;

  groups: any[] = [
    {id: 'm', label: 'M'},
    {id: 't', label: 'T'},
    {id: 'm+t', label: 'M+T'},
  ]
  prefilterTrigger: boolean = false;

  public isSuggestionsFetching = false;
  public suggestions: any[] = [];
  public rotates: any[] = [];
  public activity_id: any = null;

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }

  public mounted() {
    if (this.isNew) {
      this.$store.dispatch(`${STORE_KEY}/prepareNew`, this.initParams);
    } else {
      this.$store.dispatch(`${STORE_KEY}/init`, {
        id: this.documentPreview.id
      });
    }
  }

  checkAllowLine(row: any) {
    console.log('checkAllowLine =>', row)
    console.log('checkAllowLine =>', this.form.base_ids)
    return row.base_ids.filter((item: any) => {
      return !item || (item == this.form.base_id && !row.volume_is_full) || row.volume_type == 'pail' 
    }).length > 0 
  }

  changeValue(field: string, value: any) {
    if (field == 'base_id') {
      this.prefilterTrigger = !this.prefilterTrigger;
    }
    this.$store.dispatch(`${STORE_KEY}/changeFormValue`, {
      field, newValue: value
    });
  }

  addItem(storage_id: any) {
    this.$store.dispatch(`${STORE_KEY}/addItem`, {storage_id});
  }

  removeItem(index: any) {
    this.$store.dispatch(`${STORE_KEY}/removeItem`, index);
  }

  addAttachments(file: any) {
    this.$store.dispatch(`${STORE_KEY}/addAttachments`, {newValue: file});
  }

  changeStorageValue(index: number, field: string, value: any) {
    this.$store.dispatch(`${STORE_KEY}/changeStorageValue`, {
      index, field, newValue: value
    });
  }

  onStarterTypeChange($event: any) {
    console.log($event)
    if ($event && $event.label) {
      this.form.activity_id = $event.activity_id;
      console.log($event)
      this.rotates = $event.rotate_ids
    }
  }

  prefilterStarterTypes(item: any, index: number) {
    return item.starter_type == this.form.starter_type;
  }

  // Оборудование розлива фильтруется серверно (rel-field="type" rel-filter-in),
  // см. комбобокс «Оборудование» выше: записи voc_volumes типов line/cone.

  // При выборе оборудования на новой партии номер генерируется по формату
  // «Префикс + буква времени суток + -NN», NN — порядковый в рамках смены
  // для этого оборудования (КД-01, А160Д-01, ...). При очистке выбора номер
  // возвращается к простому порядковому. Ручная правка сохраняется.
  // Сборка номера — чистая функция buildEquipmentBatchNumber (unit-тесты).
  // Combobox после загрузки списка эммитит input-object(undefined) без
  // действия пользователя — такую синтетику игнорируем.
  onEquipmentChange(equipment: any) {
    if (!this.isNew) return;

    if (equipment === undefined && this.previousEquipmentId == null) return;
    this.previousEquipmentId = equipment && equipment.id ? equipment.id : null;

    this.changeValue('number', buildEquipmentBatchNumber(
      equipment,
      this.relatedPlansList,
      this.relTimeOfDay,
    ));
  }

  prefilterRotates(item: any, index: number) {
    return this.rotates.includes(item.id);
  }

  saveFormData() {
    this.$v.form.$touch()

    if(!this.$v.form.$error) {
      this.$store.dispatch(`${STORE_KEY}/saveForm`, this.documentPreview ? this.documentPreview.id : null)
      .then((result) => {
        this.$buefy.snackbar.open(`Данные успешно сохранены`);
        this.$v.form.$reset();

        this.$emit('form-close');
        (this.$parent as any).close();
      })
      .catch(() => {
        this.$buefy.snackbar.open({
          type: 'is-warning',
          message: `При сохранении возникли проблемы. Попробуйте позже.`
        })
      })
    }

  }

  beforeDestroy() {
    this.$store.dispatch(`${STORE_KEY}/reset`);
    // this.$store.unregisterModule(STORE_KEY);
  }
}

